import * as React from 'react';
import propz from 'propz';
import Moment from 'moment';
import { SchoolInvite } from 'Src/models/invite';
import { AppUser } from 'Src/views/App/App';
import { getTournamentLocation } from 'Src/helpers/invite/invite';
import { TournamentInviteBookingModalContent } from '../TournamentInviteBookingModalContent';
import { TournamentInviteEventSelection } from '../TournamentInviteEventSelection';

interface Props {
  invite: SchoolInvite;
  user: AppUser;
  onCancel: () => void;
  onAccept: () => void;
  events: any[];
  selectedEventIds: string[];
  eventSelectionError: string;
  onEventSelectionChange: (eventIds: string[]) => void;
}

export function AcceptTournamentInviteWithoutAutoEnrollmentTeams(props: Props) {
  const { onCancel, onAccept, invite, user, events, selectedEventIds, eventSelectionError, onEventSelectionChange } = props;
  const { activeSchoolId } = user;
  const { tournament, inviterSchool } = invite;

  if (!tournament) {
    return null;
  }

  const tournamentLocation = getTournamentLocation(invite, activeSchoolId);
  const tournamentSportName = propz.get<string>(tournament, ['sport', 'name'], '');
  const tournamentName = propz.get<string>(tournament, ['name'], '');
  const tournamentStartTime = propz.get<string>(tournament, ['startTime']);
  const tournamentStartTimeFormatted = tournamentStartTime
    ? Moment(tournament.startTime).format('DD.MM.YYYY / HH:mm')
    : '';

  const inviterSchoolName = propz.get<string>(inviterSchool, ['name'], '');
  return (
    <TournamentInviteBookingModalContent
      title="Join waiting list"
      description="This tournament is currently full. If you continue, your school will be placed on the waiting list."
      details={[
        { label: 'Tournament', value: tournamentName },
        { label: 'Organiser', value: inviterSchoolName },
        { label: 'Sport', value: tournamentSportName },
        { label: 'Start time', value: tournamentStartTimeFormatted },
        { label: 'Venue', value: tournamentLocation }
      ]}
      onClose={onCancel}
      isWaitingList={true}
      actions={
        <React.Fragment>
          <button type="button" className="tournamentBookingModal__button" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="tournamentBookingModal__button isPrimary" onClick={onAccept}>
            Join waiting list
          </button>
        </React.Fragment>
      }
    >
      <TournamentInviteEventSelection
        events={events}
        selectedEventIds={selectedEventIds}
        error={eventSelectionError}
        onChange={onEventSelectionChange}
      />
    </TournamentInviteBookingModalContent>
  );
}

